var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileInfocomponent = function SvgFileInfocomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: "file-info_component_svg__icon file-info_component_svg__icon-tabler file-info_component_svg__icons-tabler-filled file-info_component_svg__icon-tabler-file-info",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 2 .117.007a1 1 0 0 1 .876.876L13 3v4l.005.15a2 2 0 0 0 1.838 1.844L15 9h4l.117.007a1 1 0 0 1 .876.876L20 10v9a3 3 0 0 1-2.824 2.995L17 22H7a3 3 0 0 1-2.995-2.824L4 19V5a3 3 0 0 1 2.824-2.995L7 2zm0 12h-1a1 1 0 0 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1l-.007-.117a1 1 0 0 0-.876-.876L13 18v-3a1 1 0 0 0-1-1m.01-3H12a1 1 0 0 0-.117 1.993l.127.007a1 1 0 0 0 0-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7h-4l-.001-4.001z"
  })));
};
export default SvgFileInfocomponent;